// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"ConsignedTires_modalBody__2qDCg","modalFooter":"ConsignedTires_modalFooter__1kXF9"};